"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _core = require("@material-ui/core");
var _paginatedTable = require("@bento-core/paginated-table");
var _util = require("@bento-core/util");
var _defaultStyle = _interopRequireDefault(require("./defaultStyle"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
var ProfileViewFooter = function ProfileViewFooter(_ref) {
  var classes = _ref.classes,
    data = _ref.data,
    ignoredArms = _ref.ignoredArms,
    profileArmsTable = _ref.profileArmsTable,
    tblThemeConfig = _ref.tblThemeConfig,
    _ref$nodeLevelAccess = _ref.nodeLevelAccess,
    nodeLevelAccess = _ref$nodeLevelAccess === void 0 ? true : _ref$nodeLevelAccess,
    nodeLabel = _ref.nodeLabel;
  var _data$getMyUser = data.getMyUser,
    role = _data$getMyUser.role,
    userStatus = _data$getMyUser.userStatus;
  /**
   * Determines whether a given role can access the DAR button
   * @param {string} userRole The user's role
   * @returns boolean
   */
  var canAccessButton = function canAccessButton(userRole) {
    var roles = ['member', 'non-member'];

    // User must be one of the roles above
    if (!roles.includes(userRole)) {
      return false;
    }
    return true;
  };
  var renderAdmin = function renderAdmin() {
    return /*#__PURE__*/_react.default.createElement(_core.Box, {
      sx: {
        width: '100%',
        'border-top': '1px solid #89b5da',
        'border-bottom': '1px solid #89b5da',
        padding: '80px',
        'text-align': 'center',
        'font-weight': 'bold'
      }
    }, /*#__PURE__*/_react.default.createElement(_core.Paper, {
      elevation: 0
    }, /*#__PURE__*/_react.default.createElement("div", null, "You have access to all", ' ', nodeLevelAccess ? _util.custodianUtils.getNodeLevelLabel(nodeLabel, nodeLevelAccess) : 'data')));
  };
  var renderRequestButton = function renderRequestButton() {
    return canAccessButton(role) ? /*#__PURE__*/_react.default.createElement(_core.Box, {
      textAlign: "center",
      sx: {
        width: '100%'
      }
    }, /*#__PURE__*/_react.default.createElement(_core.Button, {
      className: classes.btnRequest
    }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
      to: "/request",
      className: classes.btnRequestLink
    }, "Request Access"))) : '';
  };
  var renderInactive = function renderInactive() {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.Box, {
      sx: {
        width: '100%',
        'border-top': '1px solid #89b5da',
        'border-bottom': '1px solid #89b5da',
        padding: '80px',
        'text-align': 'center',
        'font-weight': 'bold'
      }
    }, /*#__PURE__*/_react.default.createElement(_core.Paper, {
      elevation: 0
    }, /*#__PURE__*/_react.default.createElement("div", null, "You have no access to data."))), renderRequestButton());
  };
  var formatDate = function formatDate() {
    var removeRevokedStatus = function removeRevokedStatus(dataItem) {
      return ignoredArms.indexOf(dataItem.accessStatus.toLowerCase()) === -1;
    };
    var newData = JSON.parse(JSON.stringify(_objectSpread({}, data)));
    newData.getMyUser.acl = newData.getMyUser.acl.filter(removeRevokedStatus);
    /* eslint no-param-reassign: ["error", { "props": false }] */
    (newData.getMyUser.acl || []).forEach(function (element) {
      element.requestDate = (0, _util.getDateInFormat)(element.requestDate, '/');
      element.reviewDate = (0, _util.getDateInFormat)(element.reviewDate, '/');
    });
    return newData.getMyUser;
  };
  var gridConfig = profileArmsTable;
  var initTblState = function initTblState(initailState) {
    return _objectSpread(_objectSpread({}, initailState), {}, {
      title: gridConfig.title,
      columns: gridConfig.columns,
      tableMsg: gridConfig.tableMsg,
      rowsPerPage: 10,
      sortBy: gridConfig.defaultSortField,
      sortOrder: gridConfig.defaultSortDirection || 'asc',
      page: 0
    });
  };
  var formatedData = formatDate()[gridConfig.dataField];
  var renderGrid = function renderGrid() {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", null, gridConfig.display ? /*#__PURE__*/_react.default.createElement("div", {
      id: "table_profile",
      className: classes.tableDiv
    }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
      container: true
    }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/_react.default.createElement(_paginatedTable.TableView, {
      initState: initTblState,
      server: false,
      tblRows: formatedData,
      totalRowCount: formatedData.length,
      themeConfig: tblThemeConfig
    })))) : '', renderRequestButton()));
  };
  if (userStatus === 'non-member' && data.getMyUser.acl.length === 0) {
    return renderInactive();
  }
  if (role === 'admin' && userStatus === 'active') {
    return renderAdmin();
  }
  return renderGrid();
};
var _default = (0, _core.withStyles)(_defaultStyle.default, {
  withTheme: true
})(ProfileViewFooter);
exports.default = _default;